"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.getCoordinatesByHue=function(e,t){return e/360*t};
